<template>
  <footer class="forgeron-footer forgeron-custom-footer">
    <div class="footer-content d-flex justify-content-between align-items-center">
      <slot />
    </div>
  </footer>
</template>
<script>
import { Link } from '@inertiajs/vue3';

export default {
  props: {},
  components: {
    Link
  },
  setup(props) {
    return {};
  },
}
</script>